import React, { Component, useEffect, useRef, useState } from 'react';
import SideBar from '../side-bar/side-bar';
import { ToastContainer, toast } from 'react-toastify';
import MainMenuBtn from '../menu-settings/main-menu-btn';
import FilterModel from '../../data/filter-model';
import SynergyModel from '../../data/synergy-model';
import { useDispatch } from 'react-redux';
import { default as magnifier } from '../magnifying-glass.svg';
import HCNLoader from '../../helpers/hcn-loader';



const SynergyView = () => {
    const provider = FilterModel.provider;
    const [synergyItems, setSynergyItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortStatus, setSortStatus] = useState(null); // null, 'enabled-first', 'disabled-first'
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;
    const dispatch = useDispatch();

    const handleSync = async () => {
        console.log('provider 232323', provider);
        HCNLoader.show(dispatch);

        try {
            await SynergyModel.remote_re_get_all(provider.id);
            await fetchSynergyItems();
        } catch (error) {
            console.log('error 232323', error);
            toast.error('Error syncing synergy');
            HCNLoader.hide(dispatch);
        }
    };

    const fetchSynergyItems = async () => {
        HCNLoader.show(dispatch);
        try {
            const response = await SynergyModel.remote_getAll(provider.id, true);
            setSynergyItems(response || []);
            setCurrentPage(1);
        } catch (error) {
            console.log('error fetching items', error);
            toast.error('Error fetching synergy items');
        } finally {
            HCNLoader.hide(dispatch);
        }
    };

    useEffect(() => {
        fetchSynergyItems();
    }, [provider.id]);

    // Pagination logic
    let filteredItems = synergyItems.filter(item => {
        const searchLower = searchTerm.toLowerCase();
        return (
            (item.code && item.code.toLowerCase().includes(searchLower)) ||
            (item.description && item.description.toLowerCase().includes(searchLower))
        );
    });

    if (sortStatus === 'enabled-first') {
        filteredItems.sort((a, b) => (a.enabled === b.enabled ? 0 : a.enabled ? -1 : 1));
    } else if (sortStatus === 'disabled-first') {
        filteredItems.sort((a, b) => (a.enabled === b.enabled ? 0 : a.enabled ? 1 : -1));
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleSortStatus = () => {
        if (sortStatus === null) {
            setSortStatus('enabled-first');
        } else if (sortStatus === 'enabled-first') {
            setSortStatus('disabled-first');
        } else {
            setSortStatus(null);
        }
    };

    const handleItemStatus = (item) => {
        console.log('item 232323', item);
        HCNLoader.show(dispatch);

        SynergyModel.remote_editOne(provider.id, item.code)
                                                    .then((response) => {
                                                        console.log('response 232323', response);
                                                        item.enabled = response.enabled;
                                                        setSynergyItems([...synergyItems]);
                                                        HCNLoader.hide(dispatch);
                                                    })
                                                    .catch((error) => {
                                                        console.log('error 232323', error);
                                                        toast.error('Error updating synergy item status');
                                                        HCNLoader.hide(dispatch);
                                                    });
    };

    return (
        <div>
            <ToastContainer />
            <div className="divider grid-flex">
                <SideBar />
                <div id="page" className="site">
                    <div className="main-content">
                        <header className='site-header'>
                            <div className="flex-between">
                                <h1 className="main-title">
                                    Synergy
                                </h1>
                                <div className="side-functionality">
                                    <div className="side-button grid-flex">
                                        <button type="button" className="btn default-btn" onClick={handleSync}>
                                            Sync
                                        </button>
                                        <MainMenuBtn />
                                    </div>
                                </div>
                            </div>
                        </header>
                        <main>
                            <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div className="search-bar-container" style={{ width: '80%', marginTop: '20px', display: 'flex', alignItems: 'center', position: 'relative' }}>
                                    <input
                                        type="search"
                                        placeholder="Search by code or description"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setCurrentPage(1); // Reset to first page on search
                                        }}
                                        style={{
                                            width: '100%',
                                            padding: '12px 40px 12px 15px',
                                            fontSize: '16px',
                                            border: '1px solid #ddd',
                                            borderRadius: '25px',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                            outline: 'none',
                                            transition: 'border-color 0.3s ease'
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#4CAF50'}
                                        onBlur={(e) => e.target.style.borderColor = '#ddd'}
                                    />
                                    <img 
                                        src={magnifier} 
                                        alt="search" 
                                        style={{ 
                                            position: 'absolute', 
                                            right: '15px', 
                                            width: '20px', 
                                            height: '20px', 
                                            opacity: 0.6 
                                        }} 
                                    />
                                </div>
                                <table className="table" style={{ width: '80%', marginTop: '20px', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #333', width: '20%' }}>Code</th>
                                            <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #333', width: '50%' }}>Description</th>
                                            <th 
                                                style={{ padding: '10px', textAlign: 'right', border: '1px solid #333', width: '30%', cursor: 'pointer', userSelect: 'none' }}
                                                onClick={handleSortStatus}
                                                title="Click to sort by status"
                                            >
                                                Status {sortStatus === 'enabled-first' ? '↓' : sortStatus === 'disabled-first' ? '↑' : ''}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ padding: '10px', border: '1px solid #333', width: '20%', wordWrap: 'break-word' }}>{item.code}</td>
                                                <td style={{ padding: '10px', border: '1px solid #333', width: '50%', wordWrap: 'break-word' }}>{item.description}</td>
                                                <td style={{ padding: '10px', border: '1px solid #333', textAlign: 'right', width: '30%' }}>
                                                    <button
                                                        className={`btn`}
                                                        style={{
                                                            padding: '5px 15px',
                                                            backgroundColor: item.enabled ? '#4CAF50' : '#f44336',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => handleItemStatus(item)}
                                                    >
                                                        {item.enabled ? 'Enabled' : 'Disabled'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {synergyItems.length > 0 && (
                                    <div style={{ marginTop: '20px', display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                        <button
                                            onClick={() => paginate(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="btn"
                                            style={{ padding: '5px 10px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                                        >
                                            Prev
                                        </button>
                                        <span style={{ padding: '5px 10px' }}>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                        <button
                                            onClick={() => paginate(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="btn"
                                            style={{ padding: '5px 10px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SynergyView;